import { Card, CardBody, Table } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { alphaToggleAtom } from '../../atoms/alpha';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import usePoll from '../../hooks/poll';
import { POLL_FREQUENCIES } from '../../utils/polling';
import themeHelper from '../../utils/themeHelper';
import CardHeader from '../CardHeader';
import CellHeadings from '../CellHeadings';
import EmptyQueue from '../EmptyQueue';

const UploadsHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: ${themeHelper.spacing()};
`;

export function DownloadsInProgress({ displayCount }) {
  const api = useApi();
  const intl = useIntl();

  const isAlphaEnabled = useAtomValue(alphaToggleAtom);

  const getAllData = async () => {
    await api.get(`${API_ENDPOINTS.videoService}/downloads`);
  };
  const downloads = api.response?.data?.downloads.slice(0, displayCount);
  const approxQueueLength =
    api.response?.data?.approximate_queue_count ||
    intl.formatMessage({
      defaultMessage: 'TBC',
      id: '23af5',
    });

  usePoll(getAllData, POLL_FREQUENCIES.DOWNLOADS);

  return (
    <Card>
      <CardHeader>
        <UploadsHeader>
          <FormattedMessage
            defaultMessage="Uploads From URL (Approximate queue length: {approxQueueLength})"
            id="c15fb"
            values={{ approxQueueLength }}
          />
          {isAlphaEnabled && <EmptyQueue />}
        </UploadsHeader>
      </CardHeader>
      <CardBody>
        <Table>
          <CellHeadings
            cells={[
              {
                children: intl.formatMessage({
                  defaultMessage: 'Destination',
                  description: 'Destination',
                  id: 'ef9ff',
                }),
                id: 'Destination',
              },
              {
                children: intl.formatMessage({
                  defaultMessage: 'Status',
                  description: 'Status',
                  id: 'dc56e',
                }),
                id: 'Status',
              },
              {
                children: intl.formatMessage({
                  defaultMessage: 'Updated At',
                  id: 'f47b8',
                }),
                id: 'UpdatedAt',
              },
            ]}
            textAlign="left"
          />
          <Table.Body>
            {!downloads || downloads.length < 1 ? (
              <Table.Row key="table-row-empty-download">
                <Table.DataCell $textAlign="left" colSpan={3}>
                  {intl.formatMessage({
                    defaultMessage: 'Uploads from URL will appear here',
                    id: '05ec4',
                  })}
                </Table.DataCell>
              </Table.Row>
            ) : (
              downloads.map((download) => (
                <Table.Row key={`table-row-${download.download_id}`}>
                  <Table.DataCell $textAlign="left">
                    {download.download_destination}
                  </Table.DataCell>
                  <Table.DataCell $textAlign="left">
                    {download.download_status}
                  </Table.DataCell>
                  <Table.DataCell $textAlign="left">
                    {moment(download.last_updated).fromNow()}
                  </Table.DataCell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
      </CardBody>
    </Card>
  );
}

DownloadsInProgress.propTypes = {
  displayCount: PropTypes.number,
};

DownloadsInProgress.defaultProps = {
  displayCount: 5,
};

export default { DownloadsInProgress };
